import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getSalesHistoryData } from "../../features/salesHistory/salesHistorySlice";
import SalesHistoryTable from "../../features/salesHistory/salesHistoryTable";
import PdfIcon from "../IconComp/pdfIcon";
import EditIcon from "../IconComp/editIcon";
import AppModal from "../common/AppModal";
import { ReturnInvoiceModal } from "../return-item/return-invoice-model";
import { InvoiceModal } from "./invoice-model";
import LoadingSpinner from "../common/Loading";
import styles from "./styles";

const headerData = [
  "Invoice Number",
  "Date",
  "Total Amount(RS.)",
  "Discount(%)",
  "Discount Amount",
  "Total Payable",
  "Paid",
  "Due(s)",
  "Returned",
  "Action",
];

const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const RecentSales = ({ setOpenSnackbar }: any) => {
  const dispatch = useAppDispatch();
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [invoiceId, setInvoiceId] = useState<any>();
  const [sale, setSale] = useState<any>([]);
  const [isReturnModal, setIsReturnModal] = useState(false);
  const pharmacyId = localStorage?.getItem("pharmacyId");
  const rowData: { salesHistoryDetails: any } = useAppSelector(
    (state) => state?.salesHistory
  );
  const selectedDate = getCurrentDate();
  const print = true;

  const getSalesHistory = useCallback(async () => {
    const dto: any = {
      page: page + 1,
      limit: rowsPerPage,
      start_date: selectedDate,
      // end_date: selectedDate,
    };
    try {
      setIsLoading(true);
      const res = await dispatch(
        getSalesHistoryData({ pharmacy_id: pharmacyId, dto })
      );
      if (res.payload) {
        setTotalCount(res?.payload?.pagination?.totalItems || 0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  }, [dispatch, pharmacyId, page, rowsPerPage, selectedDate]);

  useEffect(() => {
    getSalesHistory();
  }, [getSalesHistory]);

  const formatDateTime = (dateTimeString: any) => {
    const dateTime = new Date(dateTimeString);
    const date = `${dateTime.getFullYear()}-${(dateTime.getMonth() + 1)
      .toString()
      .padStart(2, "0")}-${dateTime.getDate().toString().padStart(2, "0")}`;
    return date;
  };

  const sortedInvoices = [
    ...(rowData?.salesHistoryDetails?.invoice || []),
  ].sort(
    (a, b) =>
      new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );
  const handleOpenInvoiceModal = (
    invoiceNumber: any,
    sales: any,
    isReturn: any
  ) => {
    setInvoiceId(invoiceNumber);
    setSale(sales);
    setIsReturnModal(isReturn);
    setOpenInvoiceModal(true);
  };
  const handleCloseInvoiceModal = () => {
    setOpenInvoiceModal(false);
  };

  const tableRowData = sortedInvoices
    // ?.filter((item) => formatDateTime(item?.invoice_date) === selectedDate)
    ?.map((item: any) => {
      return {
        "Invoice Number": item?.is_return ? (
          <>
            <Box>{item?.id}</Box>
            <span style={{ color: "#F0483E" }}>Return Invoice</span>
          </>
        ) : (
          item?.id
        ),
        Date: formatDateTime(item?.invoice_date),
        "Total Amount(RS.)": item?.total_Amount
          ? item?.total_Amount?.toFixed(2)
          : "0.00",
        "Discount(%)": item?.discount_percentage
          ? item?.discount_percentage?.toFixed(2)
          : "0.00",
        "Discount Amount": item?.discount_Amount
          ? item?.discount_Amount?.toFixed(2)
          : "0.00",
        "Total Payable": item?.after_discount_amount
          ? item?.after_discount_amount?.toFixed(2)
          : "0.00",
        Paid: item?.paid_amount ? item?.paid_amount?.toFixed(2) : "0.00",
        "Due(s)": item?.due_amount ? item?.due_amount?.toFixed(2) : "0.00",
        Returned: item?.return_amount
          ? item?.return_amount?.toFixed(2)
          : "0.00",
        Action: (
          <Box sx={styles.actionBox}>
            <IconButton aria-label="edit">
              <EditIcon />
            </IconButton>
            <IconButton aria-label="view">
              <PdfIcon
                onClick={() =>
                  handleOpenInvoiceModal(item?.id, item?.sales, item?.is_return)
                }
              />
            </IconButton>
          </Box>
        ),
        Id: item?.id,
        sales: item?.sales,
        return: item?.is_return,
        // Add all fields you want to show in the edit box below
        _full: item,
      };
    });

  return (
    <Box sx={styles.rootBox}>
      {isLoading ? (
        <Box sx={styles.loadingBox}>
          <LoadingSpinner />
        </Box>
      ) : tableRowData && tableRowData?.length > 0 ? (
        <>
          <SalesHistoryTable
            headerData={headerData}
            rowData={tableRowData}
            onRowClick={() => {}}
            onActionClick={handleOpenInvoiceModal}
            page={page}
            showEditIcon={true}
            rowsPerPage={rowsPerPage}
            totalCount={totalCount}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            isPagination={false}
            getSalesHistory={getSalesHistory}
            setOpenSnackbar={setOpenSnackbar}
          />
          <AppModal
            title="Invoice Details"
            open={openInvoiceModal}
            handleClose={handleCloseInvoiceModal}
            fullScreen={false}
            maxWidth="sm"
          >
            {isReturnModal ? (
              <ReturnInvoiceModal
                onClose={handleCloseInvoiceModal}
                invoiceId={invoiceId}
                returnItem={sale}
                isPrint={print}
                handleSubmit={handleCloseInvoiceModal}
              />
            ) : (
              <InvoiceModal
                invoiceId={invoiceId}
                onClose={handleCloseInvoiceModal}
                onSaveAndClose={handleCloseInvoiceModal}
                isPrint={print}
              />
            )}
          </AppModal>
        </>
      ) : (
        <Typography>No sales found for today.</Typography>
      )}
    </Box>
  );
};

export default RecentSales;
